// extracted by mini-css-extract-plugin
export default {"RoundedStatus":"RoundedStatus_RoundedStatus__vfRiF","RoundedClose":"RoundedStatus_RoundedClose__9Lsfk","RoundedStatusCont":"RoundedStatus_RoundedStatusCont__Uw4jo"};